export default {"src":"/_next/static/media/trendUp.03be54f6.svg","height":25,"width":24};